import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Sort, MatSort } from "@angular/material/sort";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {
  DataArray,
  AuthorizationService,
  FMIProduct,
  FMITemplate,
  FMIDivision,
  FMIPubType,
  FMILanguage,
  FMIModel,
  FMIProductService,
  FMIProductSource,
  Document,
  DocumentService,
} from "../../../shared/index";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "fmiproduct-list",
  templateUrl: "./fmiproduct-list.html",
  standalone: false,
})
export class FMIProductListComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("fmisearchModal") searchFMIModal: ModalDirective;
  @ViewChild("fmiproductEditModal") editFMIProductModal: ModalDirective;
  @ViewChild("fmiproductFilterModal") filterFMIProductModal: ModalDirective;
  @ViewChild("errPrintTemplate") errPrintTemplate: ModalDirective;
  @ViewChild("deleteConfirmation") delConfirmModal: ModalDirective;
  @ViewChild("errModal") errModal: ModalDirective;
  @ViewChild(MatSort) matSort: MatSort;

  public fmiproducts: DataArray<FMIProduct> = new DataArray<FMIProduct>(1);
  public fmiproduct: FMIProduct = new FMIProduct();
  public fmiproductUnaltered: FMIProduct = new FMIProduct();
  public fmitemplate: FMITemplate = new FMITemplate();
  public document: Document = new Document();

  public fmidivisions: FMIDivision[] = [];
  public fmimodels: FMIModel[] = [];
  public fmitemplates: FMITemplate[] = [];
  public fmipubtypes: FMIPubType[] = [];
  public fmilanguages: FMILanguage[] = [];
  public fmiproductsources: FMIProductSource[] = [];
  public historyDocuments: Document[] = [];
  public LastVersion: string = "";
  public NextVersion: string = "";

  public fmiavailabletemplates: string[] = [];
  public fmiassignedtemplates: string[] = [];

  public selected: number[] = [];
  private subscriptions: Subscription[] = [];

  public selectedProductSource = 0;
  public selectedAvailableTemplates: string[] = [];
  public selectedAssignedTemplates: string[] = [];
  public selectedModels: string[] = [];

  //SearchFMI pop-up variables
  public version = "";
  public searchProductSourceID: number;
  public searchOldPublicationNumber = "";
  public searchNewPublicationNumber = "";

  // Filter pop-up variables
  public filterApplied = false;
  public filterProductName = "";
  public filterProductDescription = "";
  public filterFMILanguage = "";
  public filterDivision = "";
  public filterCreatedBy = "";
  public filterPrintable = true;
  public filterNotPrintable = true;

  public orderBy = "CreatedOn";
  public ascending = false;
  public totalDocuments = 0;
  public total = 0;
  public currentUser = "";
  public dataEntryMode = "";
  public uploadPDF = false;
  public uploadPDFProManul = false;
  public uploadPDFFMI = false;
  public uploadAzurePDFCompleted = false;
  public uploadFMIPDFCompleted = false;
  public uploadCoverCompleted = false;

  public uploadFMIPDFError = false;
  public uploadAzurePDFError = false;
  public errMsgFMIPDF = "";
  public errMsgAzurePDF = "";

  public processing = true;
  public processingFMIPDF = false;
  public processingAzurePDF = false;

  public savingToFMI = false;
  public changesMade = false;

  public sortType = "PublicationName";
  public sortReverse = false;
  public searchFilter = "";

  public printTemplateErrorMsg = "";
  public errModalTitle = "";
  public errModalMsg = "";
  public deleteConfirmationProductName = "";
  public deleteFMIProductID = 0;

  public errFMIDocData = false;
  public isNonConforming = false;
  public updatedFileName = "";

  public isDownloading: boolean = false;
  // Angular Material table helpers
  public dataSource: MatTableDataSource<FMIProduct> =
    new MatTableDataSource<FMIProduct>([]);
  public displayedColumns: string[] = [
    "ProductName",
    "ProductDescription",
    "CreatedOn",
    "CreatedBy",
    "Division",
    "ProManualTitle",
    "Version",
    "TitaniaUrl",
    "actions",
  ];
  public localFilter = "";
  // Prevent repeated server calls caused by programmatic sort state sync
  private initialSortSynced = false;

  //NOTE: This property was referenced in the template as `[class.disabled]="disable"`
  //	However, it was not defined in the component, and switching to strictTemplate: true in tsconfig.json caused an error.
  //	Adding the property here to resolve the error since it resolved to falsy before
  //  Assumption: this may have been intended to be part of the object, but was not implemented.
  public disable = false;

  // Titania URL validation state
  public titaniaUrlValid: boolean = true; // true if empty or valid
  public titaniaUrlTouched: boolean = false; // track user interaction

  constructor(
    private _ngZone: NgZone,
    private _authorizationService: AuthorizationService,
    private _fmiproductService: FMIProductService,
    private _documentService: DocumentService,
    private http: HttpClient
  ) {
    this.subscriptions.push(
      this._fmiproductService.fmiproductsChange.subscribe(
        (fmiproducts: FMIProduct[]) => {
          this._ngZone.run(() => {
            this.total = this._fmiproductService.totalFMIProducts;
            if (this.totalDocuments === 0) {
              this.totalDocuments = this.total;
            }

            this.fmiproducts.init();
            for (const fmiproduct of fmiproducts) {
              this.fmiproducts.update(fmiproduct, true);
            }
            // Update datasource for material table
            this.dataSource.data = this.fmiproducts.Data.slice();
            this.applyLocalFilter(); // re-apply local filter if any

            // Sync mat sort state with current server-side ordering so next click toggles properly
            if (this.matSort) {
              try {
                (this.matSort as any).disableClear = true; // ensure two-state cycle (no 'clear' third state)
                // Only sync once (initial load or after full refresh). Re-applying every time can
                // trigger change detection churn; emitting an event here caused an infinite fetch loop.
                if (!this.initialSortSynced) {
                  this.matSort.active = this.orderBy;
                  this.matSort.direction = this.ascending ? "asc" : "desc";
                  // Do NOT emit sortChange here; that re-entered onSortChange and re-fetched endlessly.
                  this.initialSortSynced = true;
                }
              } catch {
                /* no-op */
              }
            }

            this.processing = false;
          });
        }
      )
    );

    this.subscriptions.push(
      this._documentService.documentCreated.subscribe((info: Document) => {
        this._ngZone.run(() => {
          if (info.Id != -1) {
            const filePathInput: any = $("#pdfFileInput");

            if (filePathInput[0].files.length > 0) {
              const file: any = filePathInput[0].files[0];

              /// Upload the file
              if (this.uploadPDFProManul) {
                this.processingAzurePDF = true;
                this.uploadAzurePDFError = false;
                this.errMsgAzurePDF = "";
              }

              if (this.uploadPDFFMI) {
                this.processingFMIPDF = true;
                this.uploadFMIPDFError = false;
                this.errMsgFMIPDF = "";
              }

              const formData: FormData = new FormData();
              formData.append(
                "files",
                file,
                this.fmiproduct.ProductSourceID.toString() + file.name
              );

              this._fmiproductService.uploadPDF(
                formData,
                this.uploadPDFProManul,
                this.uploadPDFFMI,
                this.isNonConforming,
                this.updatedFileName
              );
            }

            this.historyDocuments = [];
            this._documentService.getAllHistory(this.fmiproduct.FileMetadataID);
          }
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.fmiproductCreated.subscribe(
        (info: FMIProduct) => {
          this._ngZone.run(() => {
            if (info.Id != -1) {
              this.fmiproduct = info;
              this.dataEntryMode = "edit";
              this.uploadPDF = true;
              this.historyDocuments = [];
              this._documentService.getAllHistory(
                this.fmiproduct.FileMetadataID
              );
            }

            this.savingToFMI = false;
          });
        }
      )
    );

    this.subscriptions.push(
      this._fmiproductService.fmiproductDeleted.subscribe(
        (info: FMIProduct) => {
          this._ngZone.run(() => {
            if (info.Id != -1) {
              this.delConfirmModal.hide();

              // refresh the list
              this.processing = true;
              this.totalDocuments = 0;
              this.fmiproducts.init();
              this._fmiproductService.getFMIProducts(
                this.orderBy,
                this.ascending,
                this.filterProductName,
                this.filterProductDescription,
                this.filterFMILanguage,
                this.filterDivision,
                this.filterCreatedBy,
                this.filterPrintable,
                this.filterNotPrintable
              );
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._fmiproductService.fmiproductChange.subscribe(
        (fmiproduct: FMIProduct) => {
          this._ngZone.run(() => {
            if (fmiproduct.Id != -1) {
              this.total = this._fmiproductService.totalFMIProducts;
              this.fmiproduct = fmiproduct;
            }

            this.savingToFMI = false;
          });
        }
      )
    );

    this.subscriptions.push(
      this._documentService.historyAllDocumentsChange.subscribe(
        (documents: Document[]) => {
          this._ngZone.run(() => {
            this.historyDocuments = documents;

            // Find the most recently updated published document
            const publishedDocs = this.historyDocuments
              .filter((doc) => doc.Publishing)
              .sort((a, b) => {
                // Sort descending by ModifiedOn (or CreatedOn as fallback)
                const dateA = new Date(a.Updated || 0).getTime();
                const dateB = new Date(b.Updated || 0).getTime();
                return dateB - dateA;
              });

            if (publishedDocs.length > 0) {
              const latestDoc = publishedDocs[0];
              this.LastVersion = latestDoc.Version;
              // Calculate next version (assume format '000#')
              const nextNum = (parseInt(latestDoc.Version, 10) + 1)
                .toString()
                .padStart(latestDoc.Version.length, "0");
              this.NextVersion = nextNum;
            }
          });
        }
      )
    );

    this.subscriptions.push(
      this._fmiproductService.fmitemplateChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.fmitemplates = info;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.fmidivisionChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.fmidivisions = info;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.fmipubtypeChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.fmipubtypes = info;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.fmimodelChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.fmimodels = info;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.fmilanguageChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.fmilanguages = info;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.fmiproductsourceChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.fmiproductsources = info;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.pdfFMIChange.subscribe((result: boolean) => {
        this._ngZone.run(() => {
          const msgUploadFMI = document.getElementById(
            "divUploadCoverCompleted"
          ) as HTMLElement;
          if (typeof msgUploadFMI != "undefined" && msgUploadFMI != null) {
            msgUploadFMI.style.display = "block";
          }
          (document.getElementById("pdfFileInput") as HTMLInputElement).value =
            null;
          this.processingFMIPDF = false;
          this.uploadFMIPDFCompleted = true;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.pdfFMIError.subscribe((result: string) => {
        this._ngZone.run(() => {
          (document.getElementById("pdfFileInput") as HTMLInputElement).value =
            null;
          this.processingFMIPDF = false;
          this.uploadFMIPDFCompleted = false;

          this.uploadFMIPDFError = true;
          this.errMsgFMIPDF = result;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.pdfAzureChange.subscribe((result: boolean) => {
        this._ngZone.run(() => {
          const msgUploadAzure = document.getElementById(
            "divUploadCoverCompleted"
          ) as HTMLElement;
          if (typeof msgUploadAzure != "undefined" && msgUploadAzure != null) {
            msgUploadAzure.style.display = "block";
          }
          (document.getElementById("pdfFileInput") as HTMLInputElement).value =
            null;
          this.processingAzurePDF = false;
          this.uploadAzurePDFCompleted = true;
        });
      })
    );

    this.subscriptions.push(
      this._fmiproductService.pdfAzureError.subscribe((result: string) => {
        this._ngZone.run(() => {
          (document.getElementById("pdfFileInput") as HTMLInputElement).value =
            null;
          this.processingAzurePDF = false;
          this.uploadAzurePDFCompleted = false;

          this.uploadAzurePDFError = true;
          this.errMsgAzurePDF = result;
        });
      })
    );
  }

  ngAfterViewInit(): void {
    // Attach mat sort to data source (client-side sort still configured though we use server-side)
    if (this.dataSource) {
      this.dataSource.sort = this.matSort;
    }
  }

  // Local (client side) filter separate from server filter popup
  public applyLocalFilter() {
    if (!this.dataSource) {
      return;
    }
    const filterValue = this.localFilter.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: FMIProduct, filter: string) => {
      if (!filter) return true;
      return (
        (data.ProductName || "").toLowerCase().includes(filter) ||
        (data.ProductDescription || "").toLowerCase().includes(filter) ||
        (data.ProManualTitle || "").toLowerCase().includes(filter) ||
        (data.CreatedBy || "").toLowerCase().includes(filter) ||
        (data.Division || "").toLowerCase().includes(filter)
      );
    };
    this.dataSource.filter = filterValue;
  }

  public applyLocalFilterFromInput(target: EventTarget) {
    this.localFilter = (target as HTMLInputElement).value || "";
    this.applyLocalFilter();
  }

  public clearLocalFilter(input: HTMLInputElement) {
    if (input) {
      input.value = "";
    }
    this.localFilter = "";
    this.applyLocalFilter();
  }

  public onSortChange(sort: Sort) {
    if (!sort.active) return;
    // sort.direction cycles 'asc' | 'desc' when matSortDisableClear=true
    // Map to service parameters
    const requestedOrderBy = sort.active;
    const requestedDir = (sort.direction || "asc").toLowerCase();
    // Guard: if nothing actually changed, skip server round-trip
    if (
      requestedOrderBy === this.orderBy &&
      requestedDir === (this.ascending ? "asc" : "desc")
    ) {
      return; // no-op
    }

    this.orderBy = requestedOrderBy;
    this.ascending = requestedDir === "asc";
    this.processing = true;
    this.fmiproducts.init();
    this._fmiproductService.getFMIProducts(
      this.orderBy,
      this.ascending,
      this.filterProductName,
      this.filterProductDescription,
      this.filterFMILanguage,
      this.filterDivision,
      this.filterCreatedBy,
      this.filterPrintable,
      this.filterNotPrintable
    );
  }

  ngOnInit(): void {
    this._fmiproductService.getFMIProducts(
      this.orderBy,
      this.ascending,
      this.filterProductName,
      this.filterProductDescription,
      this.filterFMILanguage,
      this.filterDivision,
      this.filterCreatedBy,
      this.filterPrintable,
      this.filterNotPrintable
    );

    this._fmiproductService.getFMITemplates();
    this._fmiproductService.getFMIDivisions();
    this._fmiproductService.getFMIPubTypes();
    this._fmiproductService.getFMIModels();
    this._fmiproductService.getFMILanguages();
    this._fmiproductService.getFMIProductSources();

    this.currentUser = this._authorizationService.userName;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  private blobToFile = (
    theBlob: Blob,
    name: string,
    fileName: string
  ): File => {
    const blob: any = theBlob;
    blob.lastModifiedDate = new Date();
    blob.name = name;
    blob.fileName = fileName;
    return <File>theBlob;
  };

  public sortBy(field: string): void {
    if (this.orderBy == field) {
      this.ascending = !this.ascending;
    } else {
      this.ascending = true;
      this.orderBy = field;
    }

    this.processing = true;
    this.fmiproducts.init();
    this._fmiproductService.getFMIProducts(
      this.orderBy,
      this.ascending,
      this.filterProductName,
      this.filterProductDescription,
      this.filterFMILanguage,
      this.filterDivision,
      this.filterCreatedBy,
      this.filterPrintable,
      this.filterNotPrintable
    );
  }

  public setUploadTab() {
    if (this.dataEntryMode == "edit") {
      this.uploadPDF = true;
    } else {
      this.uploadPDF = false;

      this.errModalTitle = "PDF Upload Not Available";
      this.errModalMsg =
        "Please create and save the document before uploading the PDF.";
      this.errModal.show();
    }
  }

  public isSort(field: string) {
    return field == this.orderBy;
  }

  public isSortDesc(field: string) {
    return this.isSort(field) && !this.ascending;
  }

  public edit(fmiproduct: FMIProduct): void {
    this.fmiproduct = fmiproduct;
    this.fmiproductUnaltered = JSON.parse(JSON.stringify(fmiproduct));
    this.fmiproduct.IsNonConformingDocument = fmiproduct.ProductSourceID == 99;
    this.isNonConforming = this.fmiproduct.IsNonConformingDocument;
    // Initialize URL validation for existing value
    this.validateTitaniaUrl();
    // Mark as touched if a value exists so Test Link shows immediately
    this.titaniaUrlTouched = !!(
      this.fmiproduct.TitaniaUrl && this.fmiproduct.TitaniaUrl.trim()
    );

    //2023-11-30: Set PublishToPromanual value based on object value and source, not solely on source
    this.fmiproduct.PublishToProManual =
      this.fmiproduct.PublishToProManual ||
      this.fmiproduct.IsNonConformingDocument;
    const publishToProManualEl = <HTMLInputElement>(
      document.getElementById("PublishToProManual")
    );
    publishToProManualEl.checked = this.fmiproduct.PublishToProManual;

    let chkUploadPDFFMI = <HTMLInputElement>(
      document.getElementById("chkUploadPDFFMI")
    );
    chkUploadPDFFMI.checked = !this.fmiproduct.IsNonConformingDocument;
    chkUploadPDFFMI.disabled = this.fmiproduct.IsNonConformingDocument;

    this.uploadPDF = false;
    this.uploadAzurePDFCompleted = false;
    this.uploadFMIPDFCompleted = false;
    this.processingAzurePDF = false;
    this.processingFMIPDF = false;
    this.uploadFMIPDFError = false;
    this.uploadAzurePDFError = false;
    this.dataEntryMode = "edit";
    this.savingToFMI = false;
    this.changesMade = false;

    (document.getElementById("pdfFileInput") as HTMLInputElement).value = null;

    // Reset the template arrays
    this.fmiavailabletemplates = [];
    this.fmiassignedtemplates = [];
    this.selectedAvailableTemplates = [];
    this.selectedAssignedTemplates = [];

    // Load the available templates from the fmi template default list
    for (const fmitemplate of this.fmitemplates) {
      this.fmiavailabletemplates.push(fmitemplate.Name);
    }

    // load the assigned templates from the database
    if (fmiproduct.Template) {
      this.fmiassignedtemplates = fmiproduct.Template.split(",");
    }

    // remove the assigned templates from the available templates
    let idx = 0;
    for (let i = 0; i < this.fmiassignedtemplates.length; i++) {
      idx = this.fmiavailabletemplates.indexOf(this.fmiassignedtemplates[i]);
      this.fmiavailabletemplates.splice(idx, 1);
    }

    if (fmiproduct.Model) {
      this.selectedModels = fmiproduct.Model.split(",");
    } else {
      this.selectedModels = [];
    }

    this.uploadPDFProManul = true;

    this.uploadPDFFMI = chkUploadPDFFMI.checked;

    // Load the document history
    this.historyDocuments = [];
    this._documentService.getAllHistory(fmiproduct.FileMetadataID);

    this.editFMIProductModal.show();
  }

  public addTemplate(): void {
    let cdFound = false;
    let fdFound = false;

    // check to make sure PH-CD and PH-FD are not selected with more than
    // one other print template
    cdFound = this.selectedAvailableTemplates.some((e) => e === "PH-CD");
    fdFound = this.selectedAvailableTemplates.some((e) => e === "PH-FD");

    if (cdFound && fdFound && this.selectedAvailableTemplates.length > 3) {
      this.printTemplateErrorMsg =
        "Only one print template can be assigned when both PH-CD and PH-FD are selected.";
      this.errPrintTemplate.show();
      return;
    }

    // User can only choose PH-CD and PH-FD and ONE of any of the others
    // - or -
    // just one of the others

    cdFound = this.fmiassignedtemplates.some((e) => e === "PH-CD");
    fdFound = this.fmiassignedtemplates.some((e) => e === "PH-FD");

    if (cdFound && fdFound && this.fmiassignedtemplates.length === 3) {
      this.printTemplateErrorMsg = "No more print templates can be assigned.";
      this.errPrintTemplate.show();
      return;
    }

    if (cdFound && fdFound && this.selectedAvailableTemplates.length > 1) {
      this.printTemplateErrorMsg =
        "Only one more print template can be assigned.";
      this.errPrintTemplate.show();
      return;
    }

    let idx = 0;
    for (let i = 0; i < this.selectedAvailableTemplates.length; i++) {
      if (
        !cdFound &&
        !fdFound &&
        this.fmiassignedtemplates.length === 1 &&
        this.selectedAvailableTemplates[i] != "PH-CD" &&
        this.selectedAvailableTemplates[i] != "PH-FD"
      ) {
        this.printTemplateErrorMsg = "Only PH-CD or PH-FD can be added.";
        this.errPrintTemplate.show();
        return;
      }

      if (
        cdFound &&
        !fdFound &&
        this.fmiassignedtemplates.length === 2 &&
        this.selectedAvailableTemplates[i] != "PH-FD"
      ) {
        this.printTemplateErrorMsg = "Only PH-FD can be added.";
        this.errPrintTemplate.show();
        return;
      }

      if (
        !cdFound &&
        fdFound &&
        this.fmiassignedtemplates.length === 2 &&
        this.selectedAvailableTemplates[i] != "PH-CD"
      ) {
        this.printTemplateErrorMsg = "Only PH-CD can be added.";
        this.errPrintTemplate.show();
        return;
      }

      // add the selected template to the assigned template array
      this.fmiassignedtemplates.push(this.selectedAvailableTemplates[i]);

      // remove the selected template from the available print templates
      idx = this.fmiavailabletemplates.indexOf(
        this.selectedAvailableTemplates[i]
      );
      this.fmiavailabletemplates.splice(idx, 1);
    }

    // reset the selected available templates
    this.selectedAvailableTemplates = [];

    this.fmiassignedtemplates.sort();
  }

  public removeTemplate(): void {
    let idx = 0;
    for (let i = 0; i < this.selectedAssignedTemplates.length; i++) {
      // add the selected template to the available template array
      this.fmiavailabletemplates.push(this.selectedAssignedTemplates[i]);

      // remove the selected template from the assigned print templates
      idx = this.fmiassignedtemplates.indexOf(
        this.selectedAssignedTemplates[i]
      );
      this.fmiassignedtemplates.splice(idx, 1);
    }

    // reset the selected assigned templates
    this.selectedAssignedTemplates = [];

    this.fmiavailabletemplates.sort();
  }

  public download(fmiproduct: FMIProduct): void {
    if (!fmiproduct.FileMetadataID) {
      console.error("Metadata ID not found for this row:", fmiproduct);
      return;
    }

    this.isDownloading = true;

    //TODO: stop using timeout here, use subscribe or something similar instead
    this._documentService.getAllHistory(fmiproduct.FileMetadataID);

    setTimeout(() => {
      if (!this.historyDocuments || this.historyDocuments.length === 0) {
        this.isDownloading = false;
        console.error("No documents found after calling getAllHistory.");
        toastr.error("No Documents Found Under This Publication.");
        return;
      }

      const publishedDocument = this.historyDocuments.find(
        (doc: any) => doc.Publishing === true
      );

      if (publishedDocument) {
        this.triggerDownload(publishedDocument.Id);
      } else {
        this.isDownloading = false;
        console.error(
          "No published document found for metadata ID:",
          fmiproduct.FileMetadataID
        );
      }
    }, 500);
  }

  public triggerDownload(documentId: number): void {
    this._documentService.downloadPDF(documentId).subscribe(
      (response) => {
        this.isDownloading = false;
        const contentDisposition = response.headers.get("Content-Disposition");
        let fileName = `document-${documentId}.pdf`; // Default filename

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            fileName = match[1]; // Use extracted filename
          }
        }

        const blob = response.body;
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      },
      (error) => {
        console.error("Download failed:", error);
        this.isDownloading = false;
        toastr.error("Error Downloading Document.");
      }
    );
  }

  public duplicate(dupFMIProduct: FMIProduct): void {
    this.uploadPDF = false;
    this.uploadAzurePDFCompleted = false;
    this.uploadFMIPDFCompleted = false;
    this.processingAzurePDF = false;
    this.processingFMIPDF = false;
    this.uploadFMIPDFError = false;
    this.uploadAzurePDFError = false;
    this.errMsgFMIPDF = "";
    this.dataEntryMode = "add";
    this.savingToFMI = false;
    this.changesMade = false;

    (document.getElementById("pdfFileInput") as HTMLInputElement).value = null;

    this.fmiproduct = new FMIProduct();
    this.fmiproduct.Id = 0;
    this.fmiproduct.FileMetadataID = 0;
    this.fmiproduct.ProductSourceID = dupFMIProduct.ProductSourceID;
    this.fmiproduct.ProductName = dupFMIProduct.ProductName;
    this.fmiproduct.ProManualPublicationNumber =
      dupFMIProduct.ProManualPublicationNumber;
    this.fmiproduct.ProductDescription = dupFMIProduct.ProductDescription;
    this.fmiproduct.ProManualTitle = dupFMIProduct.ProManualTitle;
    this.fmiproduct.Language = dupFMIProduct.Language;
    this.fmiproduct.PubType = dupFMIProduct.PubType;
    this.fmiproduct.BookPrice = dupFMIProduct.BookPrice;
    this.fmiproduct.CDPrice = dupFMIProduct.CDPrice;
    this.fmiproduct.FlashDrivePrice = dupFMIProduct.FlashDrivePrice;
    this.fmiproduct.Division = dupFMIProduct.Division;
    this.fmiproduct.Template = dupFMIProduct.Template;
    this.fmiproduct.PublishToProManual = dupFMIProduct.PublishToProManual;
    this.fmiproduct.AllowPrinting = true;

    // Reset the template arrays
    this.fmiavailabletemplates = [];
    this.fmiassignedtemplates = [];
    this.selectedAvailableTemplates = [];
    this.selectedAssignedTemplates = [];

    // Load the available templates from the fmi template default list
    for (const fmitemplate of this.fmitemplates) {
      this.fmiavailabletemplates.push(fmitemplate.Name);
    }

    // load the assigned templates from duplicated document
    this.fmiassignedtemplates = dupFMIProduct.Template.split(",");

    // remove the assigned templates from the available templates
    let idx = 0;
    for (let i = 0; i < this.fmiassignedtemplates.length; i++) {
      idx = this.fmiavailabletemplates.indexOf(this.fmiassignedtemplates[i]);
      this.fmiavailabletemplates.splice(idx, 1);
    }

    this.selectedModels = dupFMIProduct.Model.split(",");
    this.historyDocuments = [];
    this.editFMIProductModal.show();
    // Validate duplicated URL if any
    this.validateTitaniaUrl();
    this.titaniaUrlTouched = !!(
      this.fmiproduct.TitaniaUrl && this.fmiproduct.TitaniaUrl.trim()
    );
  }

  public remove(fmiproduct: FMIProduct): void {
    this.fmiproduct = fmiproduct;
    this.deleteConfirmationProductName = fmiproduct.ProductName.toString();
    this.deleteFMIProductID = fmiproduct.Id;
    this.delConfirmModal.show();
  }

  public cancelDeleteConfirmation(): void {
    this.deleteConfirmationProductName = "";

    this.delConfirmModal.hide();
  }

  public deleteDocument(): void {
    this._fmiproductService.deleteFMIProduct(this.deleteFMIProductID);
  }

  public complete(): void {
    const template: string = this.fmiassignedtemplates.toString();
    const model: string = this.selectedModels.toString();

    this.savingToFMI = true;
    this.changesMade = true;

    // Guard: invalid Titania URL
    this.validateTitaniaUrl();
    if (this.fmiproduct.TitaniaUrl && !this.titaniaUrlValid) {
      this.savingToFMI = false;
      this.errModalTitle = "Validation Error";
      this.errModalMsg =
        "Titania Link is not a valid URL. Please correct it or clear the field.";
      this.errModal.show();
      return;
    }

    if (this.fmiproduct.Id === 0) {
      this._fmiproductService.createFMIProduct(
        this.fmiproduct,
        template,
        model,
        this.currentUser,
        this.version
      );
    } else {
      this._fmiproductService.save(
        this.fmiproduct,
        template,
        model,
        this.currentUser
      );
    }
  }

  //2023-12-01: Added else if check to see if this.fmiproduct was altered. Attempted to only replace object, but couldn't do it as complete object and shouldn't do it recursivlely
  //  best option is to refresh list

  public cancel(): void {
    this.editFMIProductModal.hide();

    // reset screen flags
    this.savingToFMI = false;
    this.processingAzurePDF = false;
    this.uploadAzurePDFCompleted = false;
    this.processingFMIPDF = false;
    this.uploadFMIPDFCompleted = false;
    this.uploadFMIPDFError = false;
    this.uploadAzurePDFError = false;
    this.uploadCoverCompleted = false;

    // refresh the list
    if (this.changesMade) {
      //changesMade only refers to saved changes
      this.reLoadFMIProducts();
    } else if (
      JSON.stringify(this.fmiproduct) !==
      JSON.stringify(this.fmiproductUnaltered)
    ) {
      // revert changes to fmiproduct (refresh list), but need to detect changes
      this.reLoadFMIProducts();

      //Note: this does not work. We can reasign values but not the object. Also attempted a loop through fmiproducts.Data to find object.
      //this.fmiproduct = this.fmiproductUnaltered;
      //var _fmi = this.fmiproducts.Data.find(x => x.Id === this.fmiproduct.Id);
      //_fmi = this.fmiproduct; //does not work
      //_fmi = JSON.parse(JSON.stringify(this.fmiproductUnaltered)); //does not work
      //_fmi.ProductDescription += 'add a little bit here'; //does not work
      //this.fmiproductUnaltered = null;
    }
  }

  private reLoadFMIProducts() {
    this.processing = true;
    this.totalDocuments = 0;
    this.fmiproducts.init();
    this.changesMade = false;
    this._fmiproductService.getFMIProducts(
      this.orderBy,
      this.ascending,
      this.filterProductName,
      this.filterProductDescription,
      this.filterFMILanguage,
      this.filterDivision,
      this.filterCreatedBy,
      this.filterPrintable,
      this.filterNotPrintable
    );
  }

  public closePrintTemplateError(): void {
    this.errPrintTemplate.hide();
  }

  public closeErrModal(): void {
    this.errModal.hide();
  }

  public UploadFile(): void {
    const filePathInput: any = $("#pdfFileInput");
    const isNonConforming = this.fmiproduct.ProductSourceID == 99;
    this.isNonConforming = isNonConforming;
    const fileNameValidation = this.fmiproduct.IsPulledFromMidlandFMI
      ? this.fmiproduct.ProManualPublicationNumber
      : this.fmiproduct.ProductName;
    let len = 14;
    if (filePathInput[0].files.length > 0) {
      const file: any = filePathInput[0].files[0];
      const fileName: string = file.name;
      len = isNonConforming ? fileName.indexOf(".") : len;
      // The file name must match the Publication Number
      if (
        (fileName.substring(0, len) != fileNameValidation &&
          !isNonConforming) ||
        (fileName.substring(0, len).toUpperCase() !=
          fileNameValidation.toUpperCase() &&
          isNonConforming)
      ) {
        this.errModalTitle = "PDF Upload Error";
        this.errModalMsg =
          "The document you selected does not match the Publication Number you entered in the Document Information tab.  Either select a different document or change the Publication Number in the Document Information tab.";
        this.errModal.show();
      } else {
        // check to make sure the version number is numeric
        if (fileName.length != len + 9 && !isNonConforming) {
          this.errModalTitle = "PDF Upload Error";
          this.errModalMsg =
            "The document you selected matches the Publication Number but does not include a valid version number.  Please add the version number and try again.";
          this.errModal.show();
        } else {
          let version = fileName.substring(len + 1).substring(0, 4);
          version = version.replace(/0/g, "");
          if (version.length == 0) {
            version = "0";
          }
          // this.isNonConforming = isNonConforming;
          const numVersion = Number(version);
          if (isNaN(numVersion) && !isNonConforming) {
            this.errModalTitle = "PDF Upload Error";
            this.errModalMsg =
              "The document you selected matches the Publication Number but does not include a valid version number.  Please add the version number and try again.";
            this.errModal.show();
          } else {
            // Add the document record
            // 20200106 mrose Translated Manual Tilte (ProManualTitle) always take precedence over English Manual Title (ProductDescription)

            const updatedFileName = isNonConforming
              ? fileNameValidation.replace("-", "") +
                "-X-" +
                this.GetDocumentType(this.fmiproduct.PubType) +
                "-XX-" +
                this.GetLanguage(this.fmiproduct.Language) +
                ".PDF"
              : fileNameValidation + ".PDF";

            this.updatedFileName = updatedFileName;

            const updatedVersion = !isNonConforming
              ? fileName.substring(len + 1).substring(0, 4)
              : this.NextVersion
              ? this.NextVersion
              : "0001";

            if (typeof this.fmiproduct.ProManualTitle === "undefined") {
              this._documentService.createDocument(
                updatedFileName,
                this.fmiproduct.FileMetadataID,
                this.fmiproduct.ProductDescription,
                updatedVersion,
                this.fmiproduct.AllowPrinting,
                this.currentUser
              );
            } else if (this.fmiproduct.ProManualTitle.length > 0) {
              this._documentService.createDocument(
                updatedFileName.substring(0, updatedFileName.indexOf(".PDF")) +
                  ".PDF",
                this.fmiproduct.FileMetadataID,
                this.fmiproduct.ProManualTitle,
                updatedVersion,
                this.fmiproduct.AllowPrinting,
                this.currentUser
              );
            } else {
              this._documentService.createDocument(
                updatedFileName.substring(0, updatedFileName.indexOf(".PDF")) +
                  ".PDF",
                this.fmiproduct.FileMetadataID,
                this.fmiproduct.ProductDescription,
                updatedVersion,
                this.fmiproduct.AllowPrinting,
                this.currentUser
              );
            }
          }
        }
      }
    } else {
      this.errModalTitle = "PDF Upload Error";
      this.errModalMsg = "PDF file must be selected.";
      this.errModal.show();
    }
  }

  private GetDocumentType(retValue: string): any {
    if (retValue == "SHOP MANUAL") {
      return "M";
    } else if (retValue == "OPERATOR") {
      return "O";
    } else if (retValue == "ELECTRICAL") {
      return "E";
    } else return "X";
  }

  private GetLanguage(retValue: string): any {
    switch (retValue) {
      case "IDO":
        return "BH";
      case "FRE-CA":
        return "CA";
      case "ENG":
        return "EN";
      case "FRE":
        return "FR";
      case "SPA-ES":
        return "LA";
      case "SPA":
        return "MX";
      case "POR":
        return "PT";
      case "RUS":
        return "RU";
      case "SWE":
        return "SV";
      case "TUR":
        return "TR";
      case "CHI":
        return "ZH";
    }
    return "XX";
  }

  public pdfFileChange() {
    this.uploadAzurePDFCompleted = false;
    this.uploadFMIPDFCompleted = false;
    this.uploadAzurePDFError = false;
    this.uploadFMIPDFError = false;
  }

  public addFMIProduct(): void {
    this.uploadPDF = false;
    this.uploadAzurePDFCompleted = false;
    this.uploadFMIPDFCompleted = false;
    this.processingAzurePDF = false;
    this.processingFMIPDF = false;
    this.uploadFMIPDFError = false;
    this.uploadAzurePDFError = false;
    this.savingToFMI = false;
    this.dataEntryMode = "add";
    this.uploadPDFProManul = true;

    const chkUploadPDFFMI = <HTMLInputElement>(
      document.getElementById("chkUploadPDFFMI")
    );
    this.uploadPDFFMI = chkUploadPDFFMI.checked;

    this.changesMade = false;

    (document.getElementById("pdfFileInput") as HTMLInputElement).value = null;

    this.fmiproduct = new FMIProduct();
    this.fmiproduct.Id = 0;
    this.fmiproduct.Division = "Surface";
    this.fmiproduct.Language = "ENG";
    this.fmiproduct.PubType = "";
    this.fmiproduct.PublishToProManual = false;
    this.fmiproduct.AllowPrinting = true;
    this.fmiproduct.ProductName = "";
    this.fmiproduct.BookPrice = 0;
    this.fmiproduct.CDPrice = 0;
    this.fmiproduct.FlashDrivePrice = 0;
    this.fmiproduct.TitaniaUrl = "";
    this.historyDocuments = [];

    this.fmiproduct.ProductSourceID = 0; //We want this to be --Select-- not a specific source

    // Reset the template arrays
    this.fmiavailabletemplates = [];
    this.fmiassignedtemplates = [];
    this.selectedAvailableTemplates = [];
    this.selectedAssignedTemplates = [];
    this.selectedModels = [];

    // Load the available templates from the fmi template default list
    for (const fmitemplate of this.fmitemplates) {
      this.fmiavailabletemplates.push(fmitemplate.Name);
    }

    this.editFMIProductModal.show();
    // Reset validation state
    this.titaniaUrlTouched = false;
    this.validateTitaniaUrl();
  }

  public openFMISearch(): void {
    this.searchFMIModal.show();
  }

  public closeFMISearch(): void {
    (<HTMLInputElement>(
      document.getElementById("searchOldPublicationNumber")
    )).value = "";
    this.searchFMIModal.hide();
  }

  public openFilter(): void {
    this.filterFMIProductModal.show();
  }

  public closeFilter(): void {
    this.filterFMIProductModal.hide();
  }

  public applyFilter(): void {
    if (
      this.filterProductName != "" ||
      this.filterProductDescription != "" ||
      this.filterFMILanguage != "" ||
      this.filterDivision != "" ||
      this.filterCreatedBy != "" ||
      this.filterPrintable == false ||
      this.filterNotPrintable == false
    ) {
      this.filterApplied = true;
    } else {
      this.filterApplied = false;
    }
    this.processing = true;
    this._fmiproductService.applyFilter(
      this.orderBy,
      this.ascending,
      this.filterProductName,
      this.filterProductDescription,
      this.filterFMILanguage,
      this.filterDivision,
      this.filterCreatedBy,
      this.filterPrintable,
      this.filterNotPrintable
    );
    this.filterFMIProductModal.hide();
  }

  public clearFilter(): void {
    this.filterProductName = "";
    this.filterProductDescription = "";
    this.filterFMILanguage = "";
    this.filterDivision = "";
    this.filterCreatedBy = "";
    this.filterPrintable = true;
    this.filterNotPrintable = true;
    this.filterApplied = false;
  }

  public pullProductMetadataFromFMI() {
    const selectedProductSource = (<HTMLInputElement>(
      document.getElementById("lstFMIProductSourceForSearch")
    )).value;
    if (selectedProductSource == "") {
      alert("Select a Product source");
      return;
    }
    const searchFMI = (<HTMLInputElement>(
      document.getElementById("searchOldPublicationNumber")
    )).value;
    if (
      !searchFMI ||
      searchFMI == undefined ||
      searchFMI == "" ||
      searchFMI.length == 0
    ) {
      alert("Enter FMI Publication Number");
      return;
    }

    this.processing = true;
    this._fmiproductService
      .getProductMetadataBySourceIDAndPubNo(
        this.searchProductSourceID,
        this.searchOldPublicationNumber
      )
      .then((fmiProduct: FMIProduct) => {
        this.processing = false;
        if (fmiProduct != null) {
          this.EnrichView(fmiProduct);
          this.closeFMISearch();
        } else {
          alert("Enter a valid FMI Publication Number.");
        }
      });
  }

  public EnrichView(value: FMIProduct) {
    this.fmiproduct.Id = value.Id;
    this.fmiproduct.Division = value.Division;
    this.selectedModels = value.Model.split(",");
    this.fmiproduct.Model = value.Model;
    this.fmiproduct.Template = value.Template;
    this.fmiproduct.Language = value.Language;
    this.fmiproduct.PubType = value.PubType;
    this.fmiproduct.PublishToProManual = true; // Skip FMI udpated as this is pulled from FMI already
    this.fmiproduct.AllowPrinting = value.AllowPrinting;
    this.fmiproduct.ProductName = value.ProductName;
    this.fmiproduct.ProductDescription = value.ProductDescription;
    this.fmiproduct.BookPrice = value.BookPrice;
    this.fmiproduct.CDPrice = value.CDPrice;
    this.fmiproduct.FlashDrivePrice = value.FlashDrivePrice;

    this.fmiproduct.ProManualPublicationNumber =
      value.ProManualPublicationNumber;
    this.fmiproduct.ProManualTitle = value.ProManualTitle;

    this.fmiproduct.ProductSourceID = value.ProductSourceID;
    this.fmiproduct.FileMetadataID = value.FileMetadataID;

    this.fmiproduct.CreatedBy = value.CreatedBy;
    this.fmiproduct.CreatedOn = value.CreatedOn;
    this.fmiproduct.ModifiedBy = value.ModifiedBy;
    this.fmiproduct.ModifiedOn = value.ModifiedOn;
    this.fmiproduct.IsPulledFromMidlandFMI = true;
    //Reset templates
    for (let i = 0; i < this.fmiassignedtemplates.length; i++) {
      if (
        this.fmiavailabletemplates.indexOf(this.fmiassignedtemplates[i]) == -1
      )
        this.fmiavailabletemplates.push(this.fmiassignedtemplates[i]);
    }
    if (this.fmiassignedtemplates.length > 0)
      this.fmiassignedtemplates.splice(0, this.fmiassignedtemplates.length);

    //Fill Assigned templates
    const templates = value.Template.split(",");
    for (let i = 0; i < templates.length; i++) {
      this.fmiassignedtemplates.push(templates[i]);
      this.fmiavailabletemplates.splice(
        this.fmiavailabletemplates.indexOf(templates[i]),
        1
      );
    }

    // reset the selected available templates
    this.selectedAvailableTemplates = [];
    this.fmiavailabletemplates.sort();
    this.fmiassignedtemplates.sort();
  }

  public ProductSourceSelected() {
    const selectedProductSource = (<HTMLInputElement>(
      document.getElementById("lstFMIProductSource")
    )).value;
    this.fmiproduct.IsNonConformingDocument = selectedProductSource == "99";
    this.isNonConforming = this.fmiproduct.IsNonConformingDocument;

    //2023-11-30: Publish to promanual only can be set independent of product source, but if non-conforming that must be checked
    const publishToProManualEl = <HTMLInputElement>(
      document.getElementById("PublishToProManual")
    );
    if (this.fmiproduct.IsNonConformingDocument) {
      publishToProManualEl.checked = true;
      this.fmiproduct.PublishToProManual = true;
    } else {
      publishToProManualEl.checked =
        this.fmiproductUnaltered.PublishToProManual;
      this.fmiproduct.PublishToProManual =
        this.fmiproductUnaltered.PublishToProManual;
    }

    const chkUploadPDFFMI = <HTMLInputElement>(
      document.getElementById("chkUploadPDFFMI")
    );
    chkUploadPDFFMI.checked = !(selectedProductSource == "99");
    chkUploadPDFFMI.disabled = selectedProductSource == "99";
  }

  get getfmipubtypes() {
    return this.fmiproduct.IsNonConformingDocument
      ? this.fmipubtypes.filter(
          (x) =>
            x.Name == "OPERATOR" ||
            x.Name == "SHOP MANUAL" ||
            x.Name == "ELECTRICAL"
        )
      : this.fmipubtypes;
  }

  // Validate Titania URL (called on change & before save)
  public validateTitaniaUrl(value?: string): void {
    const raw =
      (value !== undefined ? value : this.fmiproduct.TitaniaUrl) || "";
    const url = raw.trim();
    if (!url) {
      this.titaniaUrlValid = true; // empty allowed
      return;
    }
    try {
      const parsed = new URL(url);
      this.titaniaUrlValid =
        parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
      this.titaniaUrlValid = false;
    }
  }
}
